import { PageScrollWrap } from 'commonStyledComponents'
import styled from 'styled-components'

export const ShortWrap = styled(PageScrollWrap)`
  --cms-grid-row-gap: 0.02rem;
  --cms-grid-column-gap: 0.02rem;
  --component-video-box-vertical--border-radius: 0;
`
